import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Youtube, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#1a3c5e] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-3">
              <img
                src="https://housedesignwala.com/api/files/18b1b263-2c1d-4631-8cfa-3c743bdb0809"
                alt="HouseDesignWala"
                className="w-16 h-16 rounded-full object-cover"
              />
              <div className="font-display text-xl font-extrabold">HouseDesignWala<span className="text-[#F7941D]">™</span></div>
            </div>
            <p className="text-gray-300 italic text-sm mb-4">Hum Sirf Ghar Nahi, Khushiyaan Sajate Hain</p>
            <p className="text-white/70 text-sm leading-relaxed">India's most trusted online house design service. 500+ homes designed across all 28 states.</p>
            <div className="flex gap-2 mt-4">
              {[Facebook, Youtube, Instagram].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-[#F7941D] flex items-center justify-center transition" data-testid={`footer-social-${i}`}>
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold text-base mb-4 text-[#F7941D]">Quick Links</h4>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><Link to="/" className="hover:text-[#F7941D]">Home</Link></li>
              <li><Link to="/services" className="hover:text-[#F7941D]">Services</Link></li>
              <li><Link to="/portfolio" className="hover:text-[#F7941D]">Portfolio</Link></li>
              <li><Link to="/reviews" className="hover:text-[#F7941D]">Reviews</Link></li>
              <li><Link to="/blog" className="hover:text-[#F7941D]">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-[#F7941D]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-base mb-4 text-[#F7941D]">Our Packages</h4>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><Link to="/services/basic" className="hover:text-[#F7941D]">Basic — ₹8,500</Link></li>
              <li><Link to="/services/premium" className="hover:text-[#F7941D]">Premium — ₹13,500</Link></li>
              <li><Link to="/services/luxury" className="hover:text-[#F7941D]">Luxury — ₹20,500</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-base mb-4 text-[#F7941D]">Contact</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 mt-0.5 text-[#F7941D]" />
                <a href="tel:+919050782248" className="hover:text-white">+91 90507 82248</a>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 mt-0.5 text-[#F7941D]" />
                <a href="mailto:support@housedesignwala.com" className="hover:text-white">support@housedesignwala.com</a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 text-[#F7941D]" />
                <span>Pan India · 100% Online Service</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-white/60 text-xs">© 2026 HouseDesignWala™. All rights reserved.</p>
          <div className="flex gap-5 text-xs text-white/60">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
